<script setup lang="ts"></script>
<template>
  <div class="space-y-5">
    <div class="flex flex-col gap-1 md:flex-row md:justify-between md:gap-0">
      <div class="space-y-2 md:space-y-1">
        <div class="h-14 w-2/3 max-w-full animate-pulse rounded bg-gray-200 md:h-8 md:w-72" />
        <div class="h-8 w-3/4 max-w-full animate-pulse rounded bg-gray-200 md:h-6 md:w-72" />
      </div>
      <div>
        <div class="h-8 w-4/5 max-w-full animate-pulse rounded bg-gray-200 md:h-12 md:w-72" />
      </div>
    </div>

    <div class="flex flex-col gap-5 md:flex-row">
      <div class="h-4 w-2/3 animate-pulse rounded bg-gray-200 md:w-16" />
      <div class="h-4 w-2/3 animate-pulse rounded bg-gray-200 md:w-16" />
      <div class="h-4 w-2/3 animate-pulse rounded bg-gray-200 md:w-16" />
      <div class="h-4 w-2/3 animate-pulse rounded bg-gray-200 md:w-16" />
      <div class="h-4 w-2/3 animate-pulse rounded bg-gray-200 md:w-16" />
      <div class="h-4 w-2/3 animate-pulse rounded bg-gray-200 md:w-16" />
    </div>
    <hr class="!my-8 w-full" />
    <div class="flex items-center justify-between">
      <div class="h-4 w-2/4 max-w-full animate-pulse rounded bg-gray-200 md:w-96" />
      <div class="h-4 w-1/4 max-w-full animate-pulse rounded bg-gray-200 md:w-20" />
    </div>
  </div>
</template>
